module.exports = __webpack_public_path__ + "static/media/triathlon.17cda72c.svg";